
































import Vue from 'vue'
import { mapState } from 'vuex';
import style from './style.module.scss'

import checkbox from '@/components/controls/checkbox/checkbox.vue'
import priceInput from '@/components/controls/price-input/price-input.vue'
import { ProjectItem, FieldErrorModel } from '@/types/supplier-search';

type PriceValue = string | null | number;

enum Fields {
  Budget = 1,
  Price,
  Quantity
}

export default Vue.extend({
  name: 'budget',
  components: {
    checkbox,
    priceInput
  },
  props: {
    containerClassName: String,
    quantity: Number,
    errorModel: Object as () => FieldErrorModel,
    startBudget: Number,
    startPrice: Number,
  },
  data() {
    return {
      budget: this.startBudget,
      price: this.startPrice,
      budgetError: false,
      priceError: false,
      withoutPrice: this.$store.state.currentPosition.WithouPrice,
      lastFocusedField: Fields.Budget,
      Fields: Fields,
      style: style
    }
  },
  methods: {
    setLastFocusedField(fieldType: Fields) {
      this.lastFocusedField = fieldType;
    },
    clearError() {
      if(this.errorModel.error) {
        this.errorModel.error = false;
      }
    },
    parseFloat(value: string): number {
      const decimal = parseFloat(value)
      return isNaN(decimal) ? this.NaNWarn(value) : decimal;
    },
    NaNWarn(nanValue: string): number {
      console.warn("value is NaN, returned ZERO, expected number", nanValue)
      console.trace();
      return 0;
    },
    setValues(budget: string, price: string) {
      this.$store.dispatch('setCurrentPositionBudget', this.parseFloat(budget));
      this.$store.dispatch('setCurrentPositionPrice', this.parseFloat(price));
    }
  },
  computed: {
    ...(mapState<RootStateSupplierSearch>({
      currentPosition(state: RootStateSupplierSearch): ProjectItem {
          return state.currentPosition;
      }
    }) as MapStateToComputed<RootStateSupplierSearch>)
  },
  watch: {
    quantity(value: number) {
      if(this.withoutPrice) return;
      let budget;
      let price;

      switch (this.lastFocusedField) {
        case Fields.Budget:
          budget = this.budget == null ? 0 : this.budget;
          this.price = Number(value ? (+budget / value).toFixed(2) : 0);
          break;
        case Fields.Price:
          price = this.price == null ? 0 : this.price;
          this.budget = Number(value ? (+price * value).toFixed(2) : 0);
          break;

        default:
          break;
      }
    },
    budget(value) {
      if(this.lastFocusedField === Fields.Budget) {
        this.price = Number((+value / this.quantity).toFixed(2));
      }
      this.setValues(value, this.price ? this.price.toString() : "0");
    },
    price(value) {
      if(this.lastFocusedField === Fields.Price) {
        this.budget = Number((+value * this.quantity).toFixed(2));
      }
      this.setValues(this.budget ? this.budget.toString() : "0", value);
    },
    startPrice(value) {
      this.price = value;
    },
    startBudget(value) {
      this.budget = value;
    }
  }
})
